import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, NavItem } from 'react-bootstrap';


function Navwrapper(inverse = true, collapseOnSelect = true) {
    
    return (
        <Navbar inverse={inverse} collapseOnSelect={collapseOnSelect} >
            <Navbar.Header>
                <Navbar.Brand>
                <a className="logo" href="https://bowl.com/">BOWL.com</a>
                </Navbar.Brand>
                <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
                <Nav style={{ marginLeft:'0' }}>
                    <NavItem >
                        <Link to="/" >RESULTS</Link>
                    </NavItem>
                    <NavItem >
                        <Link to="/upcomingEvents" >UPCOMING SCHEDULE</Link>
                    </NavItem>   
                    <NavItem >
                        <Link to="/rankings">RANKINGS</Link>
                    </NavItem>
                  <NavItem >
                    <Link to="/teams">TEAMS</Link>
                  </NavItem>    
                    <NavItem >
                        <Link to="/players">PLAYERS</Link>
                    </NavItem>
                    <div className="temph">
                        <a href="https://www.bowl.com/collegiate">
                        <img className="collegiatelogo"/></a>                    
                    </div>                               
                </Nav>    

            </Navbar.Collapse>
            
        </Navbar>  
    );
}

export default Navwrapper;


// WEBPACK FOOTER //
// ./src/components/layout/Navigation.js